const getAccountingError = (errorCode) =>
  errorCode ? `accountingMessages.accounting_error_${errorCode}` : '';

export default getAccountingError;
